import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { Data } from "../../types/api";
import { SuspenseWithFlag } from "./SuspenseWithFlag";

type Props = { children: JSX.Element };
export const PreloadContentWrapper = ({ children }: Props) => {
  const q1 = useQuery(["query", "PL"], () =>
    axios.get<Data>(process.env.REACT_APP_API_QUERYURL!)
  );
  const q2 = useQuery(["query", "EN"], () =>
    axios.get<Data>(process.env.REACT_APP_API_QUERYURL_EN!)
  );

  return (
    <SuspenseWithFlag isSuspended={q1.isInitialLoading || q2.isInitialLoading}>
      {children}
    </SuspenseWithFlag>
  );
};
